import React, { useState } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import ReactFlow, { ReactFlowProvider, Controls, MiniMap, Background } from 'react-flow-renderer';
import { bezierEdgeFactory } from '@tisoap/react-flow-smart-edge';
import ContextMenu from './jsonContextMenu';
import DecisionNode from '../decisionBox';
import ProcessNode from '../processNode';
import GritComponent from './gritComponent';
import CreateNewJourney from './jsonComponents/createNewJourney';
import DnDBarComponent from './dndBar';
import { SelectComponent, TextComponent } from '../uiComponents';
import Tooltip from '@mui/material/Tooltip';
import { Button, SelectChangeEvent, TextField } from '@mui/material';
import jsonComponentsConfig from '../../constants/jsonComponents';
import useJSONEditorHook from './useJSONEditorHook';
import { jsonEditorStyles } from './jsonEditorStyles';
import JSONClaimComponent from './claimsSection';
import AADAttributeComponent from './aadAttributesSection';
import cn from 'clsx';
import { Claim, AADAttribute } from '../../xmlParsing/interfaces';
import { uploadPolicy, getToken, tenantSettingsData } from './uploadPolicyApi';
import UserFeedbackUIComponent from './userFeedbackUI';
import TOSUIComponent from './../../termsOfService';
import PromptEmailComponent from './jsonComponents/promptEmail';
import JsonValidationComponent from './jsonValidationComponent';
import PolicyUploadUIModalComponent from './policyUploadUI';
import constants from '../../constants/jsonConstants';
import StartWizard from './startWizard/startWizard';
import { generateTemplate } from './templateGenerator/templateGeneratorUtil';
import jexgSettings from '../../constants/jsonXMLsettings';
import AppSettingsComponent from './appSettingsOptionsSection';
import { PolicyDownloadUIModalComponent } from './policyDownloadUI';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import CopyrightOutlinedIcon from '@mui/icons-material/CopyrightOutlined';
import BrightnessAutoOutlinedIcon from '@mui/icons-material/BrightnessAutoOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import BrowserUpdatedOutlinedIcon from '@mui/icons-material/BrowserUpdatedOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import SaveIcon from '@mui/icons-material/Save';
import { useDispatch } from 'react-redux';
import { setFlowcharts } from '../../store';
import NewFlowchartModal from './jsonComponents/newFlowchartModal';
import uiSettings from '../../constants/jsonEditorUISettings';

const StraightSmallPadding = bezierEdgeFactory({ nodePadding: 25 });
const edgeTypes = { smart: StraightSmallPadding };
const nodeTypes = { decision: DecisionNode, process: ProcessNode };

const JsonEditorComponent = () => {
  const classes = jsonEditorStyles();
  const {
    show,
    setShow,
    anchorPoint,
    selectedNE,
    onCloseContext,
    onCloseComponent,
    reactFlowWrap,
    onInit,
    nodes,
    edges,
    rightSection,
    setRightSection,
    onNodesChange,
    onEdgesChange,
    onConnect,
    onNodeClick,
    onNodeDoubleClick,
    onNodeContextMenu,
    onNodeDragStop,
    onEdgeContextMenu,
    onPaneContextMenu,
    onEdgeUpdate,
    onEdgeUpdateStart,
    onEdgeUpdateEnd,
    onDragOver,
    onDrop,
    newClaim,
    setNewClaim,
    currentFlowchartId,
    setCurrentFlowchart,
    flowchartsList,
    subFlowList,
    onCloseCreateNewPopup,
    newAADAttribute,
    setNewAADAttribute,
    openSubFlowFC,
    currentOpenNodeId,
    setCurrentTabId,
    currentTabId,
    allComponentsData,
    deployState,
    setDeployState,
    showFeedbackComp,
    closeFeedback,
    showTOS,
    setShowTOS,
    promptEmail,
    setPromptEmail,
    allFlowcharts,
    startWizardCancel,
    deploymentEnv,
    setDeploymentEnv,
    enableJavascript,
    setEnableJavascript,
    journeyInsightsSettings,
    setJourneyInsightsSettings,
    editorState,
    downloadEnv,
    setDownloadEnv,
    templatizedDownload,
    setTemplatizedDownload,
    envsForAppSettings,
    setEnvsForAppSettings,
    addNewFlowchart
  } = useJSONEditorHook();
  const [editingFlowchartNameId, setEditingFlowchartNameId] = useState<string>('');
  const [editingFlowchartName, setEditingFlowchartName] = useState<string>('');
  const dispatch = useDispatch();
  
  return (
    <>
      {['nodeMenu', 'edgeMenu'].includes(show) && (
        <ContextMenu
          type={show === 'nodeMenu' ? 'nodeMenu' : 'edgeMenu'}
          position={anchorPoint}
          data={selectedNE}
          close={onCloseContext}
        />
      )}
      {showFeedbackComp && <UserFeedbackUIComponent closeComponent={() => closeFeedback()} />}
      {showTOS && (
        <TOSUIComponent
          closeComponent={() => {
            setShowTOS(false);
            setShow('startWizard');
          }}
        />
      )}
      <StartWizard
        show={!showTOS && show === 'startWizard'}
        onCancel={startWizardCancel}
        onUpload={() => {
          window.location.href = '/xmlEditor';
        }}
        onBuild={(param: any) => {
          if (jexgSettings.instrumentPolicyHTMLWithLR) {
            setEnableJavascript(true);
          }
          return generateTemplate(param);
        }}
        onComplete={(param: any) => {
          setShow('');
        }}
        deployState={deployState}
        setDeployState={setDeployState}
        deploymentEnv={deploymentEnv}
        setDeploymentEnv={setDeploymentEnv}
        enableJavascript={enableJavascript}
        setEnableJavascript={setEnableJavascript}
        journeyInsightsSettings={journeyInsightsSettings}
        setJourneyInsightsSettings={setJourneyInsightsSettings}
      />
      {promptEmail && (
        <PromptEmailComponent
          closeComponent={(doNotRemind: boolean) => {
            setPromptEmail(false);
            if (!doNotRemind) {
              window.setTimeout(() => {
                setPromptEmail(true);
              }, 300000);
            }
          }}
        />
      )}
      {show === 'newFCUI' && (
        <NewFlowchartModal
          closeComponent={(fcName: string | null) => {
            if (fcName) {
              addNewFlowchart("UserJourney", fcName);
            }
            setShow('');
          }}
        />
      )}
      {show === 'uploadUI' && (
        <PolicyUploadUIModalComponent
          closeComponent={() => {
            setShow('');
          }}
          deployState={deployState}
          setShow={setShow}
          deploymentEnv={deploymentEnv}
          setDeploymentEnv={setDeploymentEnv}
          enableJavascript={enableJavascript}
          setEnableJavascript={setEnableJavascript}
          setDeployState={setDeployState}
          journeyInsightsSettings={journeyInsightsSettings}
          setJourneyInsightsSettings={setJourneyInsightsSettings}
        />
      )}
      {show === 'downloadUI' && (
        <PolicyDownloadUIModalComponent
          closeComponent={() => {
            setShow('');
          }}
          enableJavascript={enableJavascript}
          setEnableJavascript={setEnableJavascript}
          downloadEnv={downloadEnv}
          setDownloadEnv={setDownloadEnv}
          templatizedDownload={templatizedDownload}
          setTemplatizedDownload={setTemplatizedDownload}
          envsForAppSettings={envsForAppSettings}
          setEnvsForAppSettings={setEnvsForAppSettings}
          journeyInsightsSettings={journeyInsightsSettings}
          setJourneyInsightsSettings={setJourneyInsightsSettings}
        />
      )}
      {show === 'popup' && currentOpenNodeId && allComponentsData[currentOpenNodeId] && (
        <GritComponent
          data={allComponentsData[currentOpenNodeId]}
          // @ts-ignore
          label={nodes.filter((node: any) => node.id === currentOpenNodeId)[0]?.data?.label || ''}
          closeGritComponent={onCloseComponent}
          openSubFlowFC={(data: any, subFlowType: string) => openSubFlowFC(data, subFlowType)}
        />
      )}
      {!showTOS && ['createNewFC'].includes(show) && (
        <CreateNewJourney
          existingFCNames={flowchartsList.reduce((acc: string[], curVal: any) => acc.concat(curVal['label']), [])}
          // @ts-ignore
          show={show}
          handleClose={(
            action: 'template' | 'cancel' | 'upload' | 'close' | 'createNew' | 'templateBuilder',
            param: any,
          ) => {
            onCloseCreateNewPopup(action, param);
            setRightSection('flowchart');
          }}
        />
      )}
      <div className="dndflow">
        <div className={cn(classes.flexCol, classes.leftMenuBar)}>
          <div
            className={cn(classes.tab, classes.flexCol, rightSection === 'flowchart' ? classes.selectedTab : '')}
            onClick={() => {
              setShow('');
              setRightSection('flowchart');
            }}
          >
            <AccountTreeOutlinedIcon className={classes.iconBorder} />
            Flowchart
          </div>
          <div
            className={cn(classes.tab, classes.flexCol, rightSection === 'claims' ? classes.selectedTab : '')}
            onClick={() => {
              setShow('');
              setRightSection('claims');
            }}
          >
            <CopyrightOutlinedIcon className={classes.iconBorder} />
            Claims
          </div>
          <div
            className={cn(classes.tab, classes.flexCol, rightSection === 'aad attributes' ? classes.selectedTab : '')}
            onClick={() => {
              setShow('');
              setRightSection('aad attributes');
            }}
          >
            <BrightnessAutoOutlinedIcon className={classes.iconBorder} />
            AAD Attributes
          </div>
          <div
            className={cn(classes.tab, classes.flexCol, rightSection === 'app settings' ? classes.selectedTab : '')}
            onClick={() => {
              setShow('');
              setRightSection('app settings');
            }}
          >
            <SettingsOutlinedIcon className={classes.iconBorder} />
            App Settings
          </div>
          <div className={cn(classes.tab, classes.actionSpace)}></div>
          <div
            className={cn(classes.tab, classes.flexCol)}
            onClick={() => {
              // create a new flowchart ID
              setShow('createNewFC');
            }}
          >
            <Tooltip title="Restart the development process" placement="right" arrow>
              <div className={cn(classes.flexCol)} style={{ alignItems: 'center' }}>
                <RestartAltOutlinedIcon className={cn(classes.iconBorder, classes.startOverColor)} />
                Start Over
              </div>
            </Tooltip>
          </div>
          <div
            className={cn(classes.tab, classes.flexCol)}
            onClick={() => {
              setShow('newFCUI');
            }}
          >
            <Tooltip title="Add a new flowchart to the current project" placement="right" arrow>
              <div className={cn(classes.flexCol)} style={{ alignItems: 'center' }}>
                <NoteAddOutlinedIcon className={cn(classes.iconBorder, classes.addFlowchartColor)} />
                Add Flowchart
              </div>
            </Tooltip>
          </div>

          <div
            className={cn(classes.tab, classes.flexCol)}
            onClick={(e) => {
              setShow('uploadUI');
            }}
          >
            <Tooltip title="Generate policies and deploy to a tenant" placement="right" arrow>
              <div className={cn(classes.flexCol)} style={{ alignItems: 'center' }}>
                <PlayArrowOutlinedIcon className={cn(classes.iconBorder, classes.runFCColor)} />
                Run Flowcharts
              </div>
            </Tooltip>
          </div>
          <a id="downloadAnchorElem" style={{ display: 'none' }}></a>
          <div
            className={cn(classes.tab, classes.flexCol)}
            onClick={(e) => {
              var dataStr = 'data:text/json;charset=utf-8,' + (uiSettings.indentProjectJson
                ? encodeURIComponent(JSON.stringify(editorState, null, 4)) : encodeURIComponent(JSON.stringify(editorState))
              );
              var dlAnchorElem: any = document.getElementById('downloadAnchorElem');
              dlAnchorElem.setAttribute('href', dataStr);
              dlAnchorElem.setAttribute('download', 'jsonEditor-' + Date.now() + '.json');
              dlAnchorElem.click();
            }}
          >
            <Tooltip title="Save the current flowcharts to reload in the editor later" placement="right" arrow>
              <div className={cn(classes.flexCol)} style={{ alignItems: 'center' }}>
                <BrowserUpdatedOutlinedIcon className={cn(classes.iconBorder, classes.downloadColor)} />
                Download JSON{' '}
              </div>
            </Tooltip>
          </div>
          <div
            className={cn(classes.tab, classes.flexCol)}
            onClick={(e) => {
              setShow('downloadUI');
            }}
          >
            <Tooltip title="Download templatized or deployable policy XML generated from the current flowcharts" placement="right" arrow>
              <div className={cn(classes.flexCol)} style={{ alignItems: 'center' }}>
                <SimCardDownloadOutlinedIcon className={cn(classes.iconBorder, classes.downloadXMLColor)} />
                Download Policies{' '}
              </div>
            </Tooltip>
            
            </div>
          <div
            className={cn(classes.tab, classes.flexCol)}
            onClick={() => {
              // create a new flowchart ID
              window.open(
                'https://gritsoftwaresystemscom-my.sharepoint.com/:w:/g/personal/lingesh_gritsoftwaresystems_com/ERdIy6GMRdJJqVkwABhJEhMB8tLb6BdvLO6dxl6T8GRo-Q?e=0JOhOp',
                '_blank',
              );
            }}
          >
            <Tooltip title="Read our Terms of Service" placement="right" arrow>
              <div>
                <MenuBookOutlinedIcon className={cn(classes.iconBorder, classes.TOSColor)} />
                Terms of Service{' '}
              </div>
            </Tooltip>
          </div>
        </div>
        <div className={classes.leftMainDivider}></div>
        <div className={classes.mainSection}>
          {/*<Button
          variant="contained"
          onClick={() => {
            // create a new flowchart ID
            console.log(tenantSettingsData)
            console.log(getToken(tenantSettingsData))
          }}
        >
        Upload Poicy
        </Button>*/}
          {rightSection === 'claims' && (
            <div className={cn(classes.claimSection, classes.flexCol)}>
              Claims
              <JSONClaimComponent
                data={newClaim}
                changeHandler={(newClaim: Claim) => {
                  setNewClaim(newClaim);
                }}
              />
            </div>
          )}
          {rightSection === 'aad attributes' && (
            <div className={cn(classes.claimSection, classes.flexCol)}>
              AAD Attributes
              <AADAttributeComponent
                data={newAADAttribute}
                changeHandler={(newAADAttribute: AADAttribute) => {
                  setNewAADAttribute(newAADAttribute);
                }}
              />
            </div>
          )}
          {rightSection === 'app settings' && (
            <div className={cn(classes.claimSection, classes.flexCol)}>
              App Settings
              <AppSettingsComponent />
            </div>
          )}

          {rightSection === 'flowchart' && <JsonValidationComponent close={(data: any) => {}} />}

          {rightSection === 'flowchart' && flowchartsList.length > 0 && currentFlowchartId && (
            <div style={{ width: '100%', height: '100%' }}>
              {currentFlowchartId !== currentTabId && (
                <Button
                  variant="outlined"
                  className="absoluteButton"
                  onClick={() => setCurrentTabId(currentFlowchartId)}
                >
                  {' '}
                  You are editing{' '}
                  {
                    constants.subFlowTypes[
                      allFlowcharts[currentTabId].flowchartType as keyof typeof constants.subFlowTypes
                    ].displayName
                  }
                  , <br />
                  Please click here to edit the main flow chart
                </Button>
              )}
              <div className="reactflow-wrapper" ref={reactFlowWrap}>
                <ReactFlowProvider>
                  <ReactFlow
                    onInit={onInit}
                    fitView
                    nodes={nodes}
                    edges={edges}
                    edgeTypes={edgeTypes}
                    onNodesChange={onNodesChange}
                    onEdgesChange={onEdgesChange}
                    onConnect={(connection: any) => {
                      if (
                        !(connection['source'] || '').startsWith('signIn') &&
                        edges.findIndex(
                          (edge: any) =>
                            edge['source'] === connection['source'] &&
                            edge['sourceHandle'] === connection['sourceHandle'],
                        ) === -1
                      ) {
                        onConnect(connection);
                      }
                    }}
                    nodeTypes={nodeTypes}
                    onNodeClick={onNodeClick}
                    onNodeDoubleClick={onNodeDoubleClick}
                    onNodeContextMenu={onNodeContextMenu}
                    onEdgeContextMenu={onEdgeContextMenu}
                    onPaneContextMenu={onPaneContextMenu}
                    onEdgeUpdate={onEdgeUpdate}
                    onEdgeUpdateStart={onEdgeUpdateStart}
                    onEdgeUpdateEnd={onEdgeUpdateEnd}
                    onDrop={onDrop}
                    onDragOver={onDragOver}
                    // zoomOnScroll={false}
                    onPaneClick={() => {
                      setShow('');
                    }}
                    onNodeDragStop={onNodeDragStop}
                    onMoveStart={() => {
                      setShow('');
                    }}
                    onNodeDragStart={() => {
                      setShow('');
                    }}
                    deleteKeyCode={null} // Keyboard node deletion can behave oddly (it's hard to temporarily disable during a popup so nodes can be unexpectedly deleted + nodes that shouldn't be deletable can be removed)
                    // style={rfStyle}
                  >
                    <Controls />
                    <Background />
                  </ReactFlow>
                </ReactFlowProvider>
              </div>
            </div>
          )}
        </div>
        {rightSection === 'flowchart' && (
          <>
            <div className={classes.mainRightDivider}></div>
            <div className={classes.rightMenuBar}>
              <div className={classes.flowchartSelector}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: (editingFlowchartNameId === '') ? '0' : '8px', marginRight: (editingFlowchartNameId === '') ? '0' : '8px', marginTop: (editingFlowchartNameId === '') ? '0' : '8px', marginBottom: (editingFlowchartNameId === '') ? '0' : '11px'}}>
                  {editingFlowchartNameId === '' && (
                    <>
                      <SelectComponent
                        changeHandler={(e: SelectChangeEvent<string>) => {
                          setShow('');
                          setCurrentFlowchart(e.target.value);
                          setCurrentTabId(e.target.value);
                        }}
                        data={{
                          value: currentFlowchartId,
                          label: 'Flowcharts',
                          options: flowchartsList,
                          color: 'white',
                        }}
                      />
                      <ModeEditOutlineSharpIcon
                        onClick={() => {
                          setEditingFlowchartNameId(currentFlowchartId);
                          setEditingFlowchartName(allFlowcharts[currentFlowchartId]['flowchartName']);
                        }}
                        className={classes.icon}
                        color="secondary"
                        sx={{ mr: 1, ml: 0 }}
                      />
                    </>
                  )}
                  {editingFlowchartNameId !== '' && (
                    <>
                      <TextField
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                          setEditingFlowchartName(e.target.value);
                        }}
                        label='Flowchart Name'
                        variant='outlined'
                        size="small"
                        value={editingFlowchartName}
                        type="textbox"
                        sx={{
                          '& .MuiInputBase-input': {
                            color: 'white',
                            opacity: '0.8'
                          },
                          '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                              borderColor: 'white',
                              opacity: '0.8'
                            }
                          },
                          '& .MuiInputLabel-root': {
                            color: 'white',
                            opacity: '0.8'
                          }
                        }}
                      />
                      <SaveIcon
                        onClick={() => {
                          dispatch(setFlowcharts({
                            flowchart: {
                              ...allFlowcharts[editingFlowchartNameId],
                              flowchartName: editingFlowchartName
                            }
                          }));
                          setEditingFlowchartName('');
                          setEditingFlowchartNameId('');
                        }}
                        className={classes.icon}
                        color={editingFlowchartName ? "secondary" : "disabled"}
                      />
                    </>
                  )}
                </div>

                {subFlowList.length > 0 && (
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      setShow('');
                      setCurrentTabId(e.target.value);
                    }}
                    data={{
                      value: currentTabId,
                      label: 'Journeys / Submit Actions',
                      options: [{ label: 'Main Flowchart', value: currentFlowchartId }].concat(subFlowList),
                      color: 'white',
                    }}
                  />
                )}
              </div>

              <DnDBarComponent tabId={currentTabId} setShow={setShow} setDeployState={setDeployState} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

// export default withAITracking(reactPlugin, JsonEditorComponent);
export default JsonEditorComponent;
